module.exports = __webpack_public_path__ + "img/mingbai1.5_527b150aa.png";